export enum TransactionStatusesEnum {
    Pending = 1,
    Confirmed = 2,
    Declined = 3,
    Executed = 4,
}

export const TransactionStatuses = [
    { value: TransactionStatusesEnum.Pending, label: 'Pending' },
    { value: TransactionStatusesEnum.Confirmed, label: 'Confirmed' },
    { value: TransactionStatusesEnum.Declined, label: 'Rejected' },
    { value: TransactionStatusesEnum.Executed, label: 'Executed' },
]